export default __webpack_public_path__ + "static/media/nano-bot.2f3102bd.png";